import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';
import {Textarea} from '../ui/textarea';

const AdditionalNotesSection = ({formData, setFormData}) => {
  return (
    <Card className="glass-effect border-gray-700">
      <CardHeader>
        <CardTitle className="text-white">Additional Notes</CardTitle>
        <CardDescription className="text-gray-300">
          Any other information you'd like to share
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Textarea
          value={formData.additionalNotes}
          onChange={e =>
            setFormData ({...formData, additionalNotes: e.target.value})}
          className="bg-gray-800 border-gray-600 text-white"
          placeholder="Additional comments, concerns, or questions..."
          rows={4}
        />
      </CardContent>
    </Card>
  );
};

export default AdditionalNotesSection;
